<template>
    <Modal
        :title="$t('billing.skipTrialVersion')"
        @ok="confirm"
        @cancel="close"
        :cancel-text="$t('message.cancel')"
        :ok-text="$t('message.confirm')"
        :show-footer="true"
    >
        <div>{{ $t('billing.skipTrialVersionDesc') }}</div>
    </Modal>
</template>
<script>
import Modal from "../../../../components/common/Modal2.vue";

export default {
    name: "TrialSkipModal",
    components: {
        Modal,
    },
    methods: {
        close() {
            this.$emit("reject");
        },
        confirm() {
            this.$emit("confirm");
        },
    },
};
</script>
